import { z } from "zod";
import { roleSchema } from "./role";

export const helpTopicSchema = z.object({
	id: z.string().optional(),
	help_category_id: z.string().optional(),
	title: z.string(),
	body: z.string(),
	description: z.string().optional(),
	video: z.instanceof(File).optional(),
	attachment: z.any().optional(),
	roles: z.array(z.object({ label: z.string(), value: z.string() })),
	category: z
		.object({
			label: z.string(),
			value: z.string(),
			slug: z.string().optional(),
		})
		.optional()
		.nullable(),
	created_by: z.string().optional(),
	created_at: z.string().optional(),
	updated_at: z.string().optional(),
});

export const helpTopicFormSchema = z.object({
	id: z.string().optional(),
	help_category_id: z.string().min(2, { message: "Required" }),
	title: z.string().min(2, { message: "Required" }),
	body: z.string().min(2, { message: "Required" }),
	description: z.string().optional().nullable(),
	video: z.instanceof(File).optional(),
	attachment: z.any().optional(),
	new_attachment: z.any().optional(),
	roles: z.array(z.object({ label: z.string(), value: z.string() }), { message: "Required" }),
	category: z
		.object({
			label: z.string(),
			value: z.string(),
		})
		.optional()
		.nullable(),
});

export type HelpTopic = z.infer<typeof helpTopicSchema>;
export type HelpTopicFormSchema = z.infer<typeof helpTopicFormSchema>;
